import FinancialHealthGraphs from './FinancialHealthGraphs'

export default FinancialHealthGraphs
